<template>
    <v-container grid-list-md fluid>

        <v-layout row wrap>
            <v-flex xs12 sm10 md10 lg10 class="float-left">
                <h2 class="success--text text-right float-left">Events at your area</h2>
            </v-flex>
            <v-flex xs12 sm2 md2 lg2 class="float-right">
                <v-btn xs2 sm2 md2 lg2 danger block large class="primary text-right float-right" @click="goToPath('/create-event')">Add Event</v-btn>
            </v-flex>
        </v-layout>

        <v-card>
            <!-- Loading -->
            <v-layout row v-if="isLoadingEvents == true">
                <v-flex class="text-xs-center">
                    <v-progress-circular :size="50" indeterminate color="default"></v-progress-circular>
                </v-flex>
            </v-layout>
            
            <!-- Not Found -->
            <v-layout row v-if="isLoadingEvents == false && (!events || events.length <= 0)">
                <v-flex class="text-xs-center">
                    <h4>No events found!</h4>
                </v-flex>
            </v-layout>
            
            <!-- Results -->
            <v-flex v-if="events.length > 0" class="hidden-header">
                <v-card>
                    <!-- Sorting, List view, calendar view -->
                    <v-card-title class="headline light--cyan-bg" color="light-blue lighten-4" light>
                        <v-flex xs12 sm6 md6 lg6>
                            <v-flex xs12 sm6 md6 lg6 class="blue--text pointer pad0">
                                <v-select
                                    label="Sort by date"
                                    single-line
                                    class="pad0"
                                    :items="filterOption"
                                    v-model="eventFilter"
                                >
                                </v-select>
                            </v-flex>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                            <!-- <h4 class="float-right text-right padLR10">Calendar view</h4>
                            <h4 class="float-right text-right">List view</h4> -->
                        </v-flex>
                    </v-card-title>
                </v-card>
                <v-layout row wrap>
                    <!-- <v-flex xs12 sm12 md12 lg12> -->
                        <!-- <v-flex xs6 sm3 md3 lg3>
                            <v-card class="pad5">
                                <h4 class="blue--text">Party</h4>
                                <h6 class="blue--text">11 events</h6>
                            </v-card>
                        </v-flex>
                        <v-flex xs6 sm3 md3 lg3>
                            <v-card class="pad5">
                                <h4 class="blue--text">Meetup</h4>
                                <h6 class="blue--text">56 events</h6>
                            </v-card>
                        </v-flex>
                        <v-flex xs6 sm3 md3 lg3>
                            <v-card class="pad5">
                                <h4 class="blue--text">Classes</h4>
                                <h6 class="blue--text">11 events</h6>
                            </v-card>
                        </v-flex>
                        <v-flex xs6 sm3 md3 lg3>
                            <v-card class="pad5">
                                <h4 class="blue--text">Outdoor</h4>
                                <h6 class="blue--text">56 events</h6>
                            </v-card>
                        </v-flex> -->
                    <!-- </v-flex> -->
                </v-layout>
                <v-data-table :headers="headers" :items="events" :search="search"  :pagination.sync="pagination" light>

                    <!-- Event List -->

                    <template slot="items" slot-scope="props">
                        <v-flex xs12 class='card-items'>
                           <events-item :props="props"> </events-item>
                        </v-flex>
                    </template>

                    <!-- Pagination -->
                    <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                    From {{ pageStart }} to {{ pageStop }}
                    </template>

                    <!-- Notifications -->
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                         Your search for "{{ search }}" found no results.
                    </v-alert>

                </v-data-table>
            </v-flex>
        </v-card>
        
         <v-layout row>
            <v-flex xs12> </v-flex>

            <v-dialog v-model="dialog" max-width="290">
                <v-card>
                    <v-card-title class="headline">Really want to delete?</v-card-title>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn color="red darken-1" flat="flat" @click="dialog = false,removeEvent()">Yes</v-btn>

                        <v-btn color="green darken-1" flat="flat" @click="dialog = false">No</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </v-container>
</template>

<script>
    import EventService from "@/services/db/EventService.js";
    import CONSTANT from "@/services/Constant.js";

    import EventItem from "./events-item/events-item.vue";
    export default {
        name: "Events",
        props: {
            // msg: String
        },
         components: {
          "events-item": EventItem,
        },
        data() {
            return {
                title: "Events",
                search: "",
                filterOption:["Date","City","State"],
                isRemoveEvent: false,
                dialog: false,
                eventFilter:"",
                removeEventId: "",
                pagination: {
                    page: 1,
                    rowsPerPage: -1,
                    totalItems: 0
                },
                headers: [
                    {
                        text: "Photo",
                        align: "left",
                        value: "photo"
                    },
                    {
                        text: "Title",
                        align: "left",
                        value: "title"
                    },
                    {
                        text: "Name",
                        align: "left",
                        value: "contact_name"
                    },
                    {
                        text: "Type",
                        align: "left",
                        value: "type"
                    },
                    {
                        text: "Website",
                        align: "left",
                        value: "website"
                    },
                    {
                        text: "Desc",
                        align: "left",
                        value: "description"
                    }
                ],
                events: [],
                isLoadingEvents: true
            };
        },
          watch: {
            eventFilter: function() {
                this.getFilteredEvent(); 
            },
            },
        created() {
            this.loadEvents();
        },
        computed: {
            /*
            * Method to check that request is authenticated or not
            */
            isAuthenticated() {
                return this.$store.getters.isAuthenticated;
            },
        },
        methods: {
            getFilteredEvent(){
                
                if(this.eventFilter == 'Date'){
                    this.eventFilter = "created_date";
                }  

                EventService.getFilteredEvents((this.eventFilter).toLowerCase())
                .then( (events) => {
                    this.clearEvents();
                    events.forEach(doc => {
                        let event = doc.data();
                        event.id = doc.id;
                        this.events.push(event) 
                    }) 
                } )
                .catch(() => {
                    // console.log({e});
                })
            },

            clearEvents(){
                this.events = []
            },

            /*
             * Method to load events
             */
            loadEvents() {
                this.isLoadingEvents = true;
                var _USER = JSON.parse(this.$store.getters.loginUser);
                EventService.getEvents(
                    _USER.userId,
                    events => {
                        this.events = [];
                        this.isLoadingEvents = false;
                        if (events) {
                            events.forEach(doc => {
                                var _obj = doc.data();
                                _obj["id"] = doc.id;
                                this.events.push(_obj);
                            });
                        }
                    }
                );
            },
            getEventDate(){
                return "25 <br /> DEC";
            },
            // goto event page
            gotoEvent(id){
                 this.$router.push('/event/'+id);
            },
            //confirmation dialog
            removeConfirmation(id){
                this.dialog = true;
                this.removeEventId = id;
            },
            //remove event
            removeEvent(){
                EventService.removeEventById(this.removeEventId)
                .then(() => {
                    this.$store.commit("setAlert", {
                        isAlertSuccess: true,
                        message: CONSTANT.MESSAGES.EVENT.REMOVE_SUCCESS 
                    });
                })
                .catch(() => {
                this.$store.commit("setAlert", {
                        isAlertError: true,
                        message: CONSTANT.MESSAGES.EVENT.REMOVE_FAIL
                    });
                });
            },
            /*
            * Method to redirect specific path
            */
            goToPath(path) {
                // this.$router.push({ name: path, params: { id: '123' } });
                this.$router.push(path);
            },
            
            /*
            * Method to redirect event details
            */
            goToEventDetails(id) {
                this.$router.push(
                    "/events-detail/" + id
                );
            },
            /*
            * Method to redirect specific path
            */
            // goToPath(path) {
            //     // this.$router.push({ name: path, params: { id: '123' } });
            //     this.$router.push(path);
            // },            
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    .content-body {
        padding: 10px;
        font-size:18px;        
    }

    .img-section {
        border: 1px solid #DDDDDD;
        width: 200px;
        height: 200px;
        position:relative;
    }

    .tag {
        float: left;
        position: absolute;
        left: 25px;
        top: 2px;
        background-color: #1A3454;
        z-index: 1;
        color: #fff;
        padding: 8px 12px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        text-align: center;
    }

    .fav-icon{
        position: absolute;
        top: 10px;
        right: 15px;
    }

</style>
